import styled from "styled-components";

export const LoginMainSection = styled("div")<any>`
  background-image: url(${(p) => (p.src ? p.src : "")});
  background-size: cover;
  height:100vh;
  display: flex;           /* establish flex container */
  flex-direction: column;  /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center;
  align-content:center;
`;


export const MainFormContainer = styled("div")`
  /* padding: 5px;  */
  /* background-color:white; */
  /* box-shadow: 1px 2px #C5C7C6  ; */
  /* border: solid 1px #C5C7C6; */
  /* border-radius: 16px; */
  /* opacity: 70%; */
  width:400px;
`;

export const FormGroup = styled("form")`
  width: 100%;
  @media only screen and (max-width: 1045px) {
    max-width: 100%;
    margin-top: 2rem;
  }
`;

export const FormContainerDiv = styled("div")`
  height:auto;
  width:100% ;
  display:flex;
  flex-direction: column;  
`;

export const ButtonContainer = styled("div")`
  display:flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height:100%;
  width:100%;
`;


export const WelcomeTitleLable = styled("p")`
  font-size: 17px;
  font-weight:700;
  color: black;
  text-align:center;
  font-family: 'IRANSansWeb';
`;

export const LoginTypeContainer = styled("div")`
  display:flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width:100%;
`;

export const ForgetPassowedContainer = styled("div")`
  display:flex;
  text-align: right;
  justify-content: right;
  align-items: center;
  height:100%;
  width:100%;
  margin-right:7px;
  font-size:12px;
`;